<div
  *ngIf="disconnected"
  class="s-full pos-abs fx-center z-index-1">
  <span class="body-2 text-style-italic bg-red-400 text-white text-500 px-1 radius-8">
    {{ labels.disconnected }}
  </span>
</div>
<app-power-state-mode-zero
  *ngIf="mode === 0"
  class="s-75 mx-auto"
  [unitLabel]="labels.unit"
  [unitSymbol]="unitSymbol"
  [valuePrecision]="valuePrecision"
  [showPowerFlow]="showPowerFlow"
  [class.disconnected]="disconnected"
  [duration]="disconnected ? 0 : duration"
  [fromSolarToHome]="fromSolarToHome">
  <div
    class="pos-rel fx-center rounded s-15 fx-col solar-circle"
    [class.solar-shadow]="solar"
    solar>
    <div class="bg-white radius-4 px-1 bg-opacity-30 pos-abs text-bold body-2 text-orange-400 pos-solar">
      {{ labels.solar }}
    </div>
    <ion-icon
      class="s-8 mt-n-1"
      [src]="pathIcons.solar">
    </ion-icon>
    <div
      *ngIf="solar"
      class="body-2 mt-0 text-orange-400 text-style-italic text-bold">
      {{ solar | measures : valuePrecision : '' }}
    </div>
  </div>
  <div
    class="pos-rel fx-center rounded s-15 fx-col home-circle"
    [class.home-shadow]="home || fromBatteryToHome || fromGridToHome || fromSolarToHome"
    home>
    <div class="bg-white radius-4 px-1 bg-opacity-30 pos-abs text-bold body-2 text-blue-400 pos-home">
      {{ labels.home }}
    </div>
    <ion-icon
      class="s-8 mt-n-1"
      [src]="pathIcons.home">
    </ion-icon>
    <div
      *ngIf="home"
      class="body-2 mt-0 text-blue-400 text-style-italic text-bold">
      {{ home | measures : valuePrecision : '' }}
    </div>
  </div>
  <div
    class="pos-rel fx-center"
    date>
    <div
      *ngIf="lastUpdated; else noLastUpdated"
      class="text-style-italic capitalize-first text-right last-updated">
      {{ lastUpdated | timeAgo:null:'long':(showSeconds ? 'withSeconds' : '24hrs') }}
      <div
        *ngIf="offset !== null && offset !== undefined"
        class="text-uppercase last-updated-utc">
        UTC {{ offset > 0 ? '+' : '-' }}{{ offset }}
      </div>
    </div>
    <ng-template #noLastUpdated>
      <ng-container *ngIf="lastUpdated === null">
        <ion-skeleton-text
          animated
          class="w-25 h-4">
        </ion-skeleton-text>
      </ng-container>
    </ng-template>
  </div>
</app-power-state-mode-zero>

<app-power-state-mode-one
  *ngIf="mode === 1"
  class="s-75 mx-auto"
  [unitLabel]="labels.unit"
  [unitSymbol]="unitSymbol"
  [valuePrecision]="valuePrecision"
  [showPowerFlow]="showPowerFlow"
  [class.disconnected]="disconnected"
  [duration]="disconnected ? 0 : duration"
  [fromSolarToHome]="fromSolarToHome"
  [fromSolarToGrid]="fromSolarToGrid"
  [fromGridToHome]="fromGridToHome">
  <div
    class="pos-rel fx-center rounded s-15 fx-col solar-circle"
    [class.solar-shadow]="solar"
    solar>
    <div class="bg-white radius-4 px-1 bg-opacity-30 pos-abs text-bold body-2 text-orange-400 pos-solar">
      {{ labels.solar }}
    </div>
    <ion-icon
      class="s-8 mt-n-1"
      [src]="pathIcons.solar">
    </ion-icon>
    <div
      *ngIf="solar"
      class="body-2 mt-0 text-orange-400 text-style-italic text-bold">
      {{ solar | measures : valuePrecision : '' }}
    </div>
  </div>
  <div
    class="pos-rel fx-center rounded s-15 fx-col grid-circle"
    [class.grid-shadow]="grid || fromSolarToGrid"
    grid>
    <div class="bg-white radius-4 px-1 bg-opacity-30 pos-abs text-bold body-2 text-grey-400 pos-grid">
      {{ labels.grid }}
    </div>
    <ion-icon
      class="s-8 mt-n-1"
      [src]="pathIcons.grid">
    </ion-icon>
    <div
      *ngIf="grid"
      class="body-2 mt-0 text-grey-400 text-style-italic text-bold">
      {{ grid | measures : valuePrecision : '' }}
    </div>
  </div>
  <div
    class="pos-rel fx-center rounded s-15 fx-col home-circle"
    [class.home-shadow]="home || fromBatteryToHome || fromGridToHome || fromSolarToHome"
    home>
    <div class="bg-white radius-4 px-1 bg-opacity-30 pos-abs text-bold body-2 text-blue-400 pos-home">
      {{ labels.home }}
    </div>
    <ion-icon
      class="s-8 mt-n-1"
      [src]="pathIcons.home">
    </ion-icon>
    <div
      *ngIf="home"
      class="body-2 mt-0 text-blue-400 text-style-italic text-bold">
      {{ home | measures : valuePrecision : '' }}
    </div>
  </div>
  <div
    class="pos-rel fx-center"
    date>
    <div
      *ngIf="lastUpdated; else noLastUpdated"
      class="text-style-italic capitalize-first text-right last-updated">
      {{ lastUpdated | timeAgo:null:'long':(showSeconds ? 'withSeconds' : '24hrs') }}
      <div
        *ngIf="offset !== null && offset !== undefined"
        class="text-uppercase last-updated-utc">
        UTC {{ offset > 0 ? '+' : '-' }}{{ offset }}
      </div>
    </div>
    <ng-template #noLastUpdated>
      <ng-container *ngIf="lastUpdated === null">
        <ion-skeleton-text
          animated
          class="w-25 h-4">
        </ion-skeleton-text>
      </ng-container>
    </ng-template>
  </div>
</app-power-state-mode-one>

<app-power-state-mode-two
  *ngIf="mode === 2 || mode === null"
  class="s-75 mx-auto"
  [unitLabel]="labels.unit"
  [unitSymbol]="unitSymbol"
  [valuePrecision]="valuePrecision"
  [class.disconnected]="disconnected"
  [showPowerFlow]="showPowerFlow"
  [duration]="disconnected ? 0 : duration"
  [fromGridToHome]="fromGridToHome"
  [fromSolarToGrid]="fromSolarToGrid"
  [fromSolarToBattery]="fromSolarToBattery"
  [fromSolarToHome]="fromSolarToHome"
  [fromBatteryToHome]="fromBatteryToHome"
  [fromGridToBattery]="fromGridToBattery"
  [fromBatteryToHome]="fromBatteryToHome">
  <div
    *ngIf="mode === 2"
    class="pos-rel fx-center rounded s-15 fx-col solar-circle"
    [class.solar-shadow]="solar"
    solar>
    <ng-container *ngTemplateOutlet="extPowerTemplate || empty"></ng-container>
    <div class="bg-white radius-4 px-1 bg-opacity-30 pos-abs text-bold body-2 text-orange-400 pos-solar">
      {{ labels.solar }}
    </div>
    <ion-icon
      class="s-8 mt-n-1"
      [src]="pathIcons.solar">
    </ion-icon>
    <div
      *ngIf="solar"
      class="body-2 mt-0 text-orange-400 text-style-italic text-bold">
      {{ solar | measures : valuePrecision : '' }}
    </div>
  </div>
  <div
    *ngIf="mode === 2"
    battery
    class="pos-rel fx-center rounded s-15 fx-col battery-circle"
    [class.battery-shadow]="batteryPercentage || fromGridToBattery || fromSolarToBattery"
    (click)="nodeClick.emit('battery')">
    <div class="bg-white radius-4 px-1 bg-opacity-30 pos-abs text-bold body-2 text-green-400 pos-battery">
      {{ labels.battery }}
    </div>
    <ion-icon
      class="s-9 mt-n-1"
      [src]="pathIcons.battery">
    </ion-icon>
    <div
      *ngIf="batteryPercentage"
      class="pos-abs s-9">
      <span
        class="pos-abs body-2 text-grey-400 text-style-italic text-bold text-nowrap d-block bg-white bg-opacity-65 radius-2"
        style="left: 2px;top: 5px;">
        {{ batteryPercentage | measures : 0 : '%' }}
      </span>
    </div>
    <div
      *ngIf="batteryPower"
      class="body-2 mt-0 text-green-400 text-style-italic text-bold">
      {{ batteryPower | measures : valuePrecision : '' }}
    </div>
  </div>
  <div
    *ngIf="mode === 2"
    class="pos-rel fx-center rounded s-15 fx-col grid-circle"
    [class.grid-shadow]="grid || fromSolarToGrid"
    grid>
    <div class="bg-white radius-4 px-1 bg-opacity-30 pos-abs text-bold body-2 text-grey-400 pos-grid">
      {{ labels.grid }}
    </div>
    <ion-icon
      class="s-8 mt-n-1"
      [src]="pathIcons.grid">
    </ion-icon>
    <div
      *ngIf="grid"
      class="body-2 mt-0 text-grey-400 text-style-italic text-bold">
      {{ grid | measures : valuePrecision : '' }}
    </div>
  </div>
  <div
    *ngIf="mode === 2"
    class="pos-rel fx-center rounded s-15 fx-col home-circle"
    [class.home-shadow]="home || fromBatteryToHome || fromGridToHome || fromSolarToHome"
    home>
    <div class="bg-white radius-4 px-1 bg-opacity-30 pos-abs text-bold body-2 text-blue-400 pos-home">
      {{ labels.home }}
    </div>
    <ion-icon
      class="s-8 mt-n-1"
      [src]="pathIcons.home">
    </ion-icon>
    <div
      *ngIf="home"
      class="body-2 mt-0 text-blue-400 text-style-italic text-bold">
      {{ home | measures : valuePrecision : '' }}
    </div>
  </div>
  <div
    class="pos-rel fx-center"
    date>
    <div
      *ngIf="lastUpdated; else noLastUpdated"
      class="text-style-italic capitalize-first text-right last-updated">
      {{ lastUpdated | timeAgo:null:'long':(showSeconds ? 'withSeconds' : '24hrs') }}
      <div
        *ngIf="offset !== null && offset !== undefined"
        class="text-uppercase last-updated-utc">
        UTC {{ offset > 0 ? '+' : '-' }}{{ offset }}
      </div>
    </div>
    <ng-template #noLastUpdated>
      <ng-container *ngIf="lastUpdated === null">
        <ion-skeleton-text
          animated
          class="w-25 h-4">
        </ion-skeleton-text>
      </ng-container>
    </ng-template>
  </div>

  <!-- skeleton mode -->
  <ion-skeleton-text
    *ngIf="mode === null"
    animated
    class="pos-rel fx-center rounded s-15 fx-col"
    solar>
  </ion-skeleton-text>
  <ion-skeleton-text
    *ngIf="mode === null"
    animated
    class="pos-rel fx-center rounded s-15 fx-col"
    battery>
  </ion-skeleton-text>
  <ion-skeleton-text
    *ngIf="mode === null"
    animated
    class="pos-rel fx-center rounded s-15 fx-col"
    grid>
  </ion-skeleton-text>
  <ion-skeleton-text
    *ngIf="mode === null"
    animated
    class="pos-rel fx-center rounded s-15 fx-col"
    home>
  </ion-skeleton-text>
</app-power-state-mode-two>

<ng-template #empty></ng-template>
